import { Col, Container, Image, Row } from "react-bootstrap";

const TermsAndConditions = () => {
  return (
    <Container className="w-100 main-container container">
      <Container className="body-text">
        <Container className="mb-4">
          <p className="mb-2">
            <b>RECITALS:</b>
          </p>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <p>A</p>
            </Col>
            <Col md={10}>
              <span>
                The Supplier ("<b>You</b>", "<b>Your</b>" or "<b>Supplier</b>")
                is engaged in the business of supplying Goods to John Lewis plc
                (“
                <b>JLP</b>”) (each a "<b>Party</b>", together the "
                <b>Parties</b>
                ").
              </span>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <p>B</p>
            </Col>
            <Col md={10}>
              <span>
                The Supplier and JLP wish to promote the Goods and Parties agree
                to enter into this Agreement for such corresponding Services.
              </span>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <p className="mb-2">
            <b>RECITALS:</b>
          </p>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <p>A</p>
            </Col>
            <Col md={10}>
              <span>
                The Supplier ("<b>You</b>", "<b>Your</b>" or "<b>Supplier</b>")
                is engaged in the business of supplying Goods to John Lewis plc
                (“
                <b>JLP</b>”) (each a "<b>Party</b>", together the "
                <b>Parties</b>
                ").
              </span>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <p>B</p>
            </Col>
            <Col md={10}>
              <span>
                The Supplier and JLP wish to promote the Goods and Parties agree
                to enter into this Agreement for such corresponding Services.
              </span>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <p className="mb-2">
            <b>It is agreed:</b>
          </p>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <p>1</p>
            </Col>
            <Col md={10}>
              <span>Definitions and interpretation</span>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <p>1.1</p>
            </Col>
            <Col md={10}>
              <span>
                In this Agreement, unless the context requires the contrary:
              </span>
            </Col>
          </Row>
          <ul>
            <li className="mb-2">
              <b>Agreement</b> means those documents listed at Clause 4.1.
            </li>
            <li className="mb-2">
              <b>Applicable Laws</b> means all legislation (primary or
              secondary), statutory provision, statutory instrument, order,
              enactment, ordinance, regulation, directive, guidance, code of
              practice or conduct or other legal or regulatory requirement in
              any relevant jurisdiction and including those of the Office of
              Communications (Ofcom), the Broadcast Committee of Advertising
              Practice (BCAP), the Committee of Advertising Practice (CAP), the
              Advertising Standards Authority (ASA), the Financial Conduct
              Authority (FCA), and any other applicable regulator or statutory
              or regulatory body relevant to the Services (or part thereof) and
              any act undertaken by either Party in relation to this Agreement.
            </li>
            <li className="mb-2">
              <b>Background IPR</b> means all Intellectual Property Rights that
              are owned by or licenced to either Party and which are (or have
              been) developed independently of this Agreement (whether prior to
              signing the Campaign Order, or otherwise).
            </li>
            <li className="mb-2">
              <b>Business Day</b> means a day, excluding a Saturday or a Sunday,
              on which banks in London are open for non-automated business.
            </li>
            <li className="mb-2">
              <b>Campaign</b> means any campaign for promotion of the Goods.
            </li>
            <li className="mb-2">
              <b>Campaign IPR</b>
              means Intellectual Property Rights that arise or are created or
              developed by either Party for JLP's use in connection with this
              Agreement and / or are adaptions of Background IPR for JLP's use
              in connection with this Agreement, but in each instance, excluding
              the Background IPR itself of either Party.
            </li>
            <li className="mb-2">
              <b>Campaign Order</b> means the form provided by JLP to You for
              the Services.
            </li>
            <li className="mb-2">
              <b>Campaign Tasks</b> means any task assigned to You as part of
              the Campaign (such as, but not limited to, window dressing).
            </li>
            <li className="mb-2">
              <b>Campaign Timetable</b> means the timeframe for undertaking
              certain tasks to ensure completion of the Services by the required
              deadline.
            </li>
            <li className="mb-2">
              <b>Cancellation Costs</b> means the costs and charges detailed
              within Clause 20.3(a) and Clause 20.3(b).
            </li>
            <li className="mb-2">
              <b>Charges</b> means the charges for the Services as given in the
              Campaign Order and payable by You in accordance with the
              provisions of Clause 11 (Charges and Payment).
            </li>
            <li className="mb-2">
              <p>
                <b>Confidential Information</b> means:
              </p>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    all confidential information and data which is acquired from
                    or made available (directly or indirectly) by the Disclosing
                    Party, or by any member of the Disclosing Party’s Group or
                    the Disclosing Party’s Representatives, including but not
                    limited to any information or document relating to the
                    Disclosing Party’s (or any of its Group’s) business,
                    operations, processes, initiatives, plans, product
                    information, pricing information, technical or commercial
                    know-how, trade secrets, specifications, inventions,
                    designs, software, market opportunities, customers or
                    suppliers (whether relating to this Agreement or otherwise),
                    either orally, in writing, or in whatever form obtained or
                    maintained;
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    any information or analysis derived from the Confidential
                    Information; and / or
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (c)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    anything marked as confidential and any other information
                    notified by or on behalf of the Disclosing Party (or any
                    member of its Group or its Representatives) to the Receiving
                    Party (or any member of its Group) as being confidential.
                  </span>
                </Col>
              </Row>
            </li>
            <li className="mb-2">
              <b>Creative Material</b> means the material produced, including
              any ancillary material, as part of the Services. For the avoidance
              of doubt, Creative Material does not include Your Background IPR
              or any IPR within any Samples.
            </li>
            <li className="mb-2">
              <b>DPA</b> means the data processing agreement (current version
              located at
              https://www.jlpinsightsandmedia.co.uk/data-processing-agreement)
              as updated by JLP from time to time.
            </li>
            <li className="mb-2">
              <b>Data Protection Laws</b> means the General Data Protection
              Regulation (EU) 2016/679 (“GDPR”), the UK GDPR, the Data
              Protection Act 2018, and all data protection and privacy laws
              applicable to the Processing of Personal Data and privacy under
              this Agreement, including local, state, national and/or foreign
              laws, treaties, and/or regulations, and implementations of EU Data
              Protection Laws into national law and the terms "Processing" and
              "Personal Data" shall have the meanings assigned in the Data
              Protection Laws.
            </li>
            <li className="mb-2">
              <b>Disclosing Party</b> means a Party that makes a disclosure of
              Confidential Information to another Party.
            </li>
            <li className="mb-2">
              <b>Force Majeure Event</b> means any event beyond the reasonable
              control of either Party which is unavoidable including, but not
              limited to, the following events: epidemics, pandemics,
              earthquakes, landslides or displacements of other materials,
              storms, floods, hurricanes, tempest, acts of God, state or public
              enemy, wars, revolutions, uprisings, hostilities, civil
              disturbances, blockades, embargoes, government restraints or
              similar disruptions or interferences with trade, riots, civil war,
              insurrection, invasion, explosions and fires. For the avoidance of
              doubt, strikes, lockouts and shutdowns of a Party or any of its
              Group (or of any person engaged by any of them) shall not be a
              Force Majeure Event for that Party.
            </li>
            <li className="mb-2">
              <b>Goods</b> means the goods and services for resale (including
              any packaging, labelling or any part or parts of them) as sold by
              You to JLP.{" "}
            </li>
            <li className="mb-2">
              <b>Goods Supply Contract</b> has the meaning given in Clause 4.1.{" "}
            </li>
            <li className="mb-2">
              <b>Group</b> means, in respect of each Party, that Party, any
              subsidiary or holding company from time to time of that Party, and
              any subsidiary from time to time of that Party’s holding
              companies, as such terms are defined in the Companies Act 2006 (or
              any replacement statutes).
            </li>
            <li className="mb-2">
              <b>GSCOP Code</b> means the Groceries Supply Code of Practice
              along with any interpretative guidance issued by the Groceries
              Code Adjudicator.
            </li>
            <li className="mb-2">
              <b>Intellectual Property Right</b> or <b>IPR</b> means any right,
              title or interest in patents, utility models, rights to
              inventions, copyright and neighbouring and related rights,
              trademarks, trade names and service marks, business names and
              domain names, rights in get-up and trade dress, goodwill and the
              right to sue for passing-off or unfair competition, rights in
              designs, rights in computer software, semiconductor topography
              rights, database rights, rights to use, and protect the
              confidentiality of, Confidential Information (including know-how
              and trade secrets) and all other intellectual property rights, in
              each case whether registered or unregistered and including all
              applications and rights to apply for and be granted, renewals or
              extensions of, and rights to claim priority from, such rights and
              all similar or equivalent rights or forms of protection which
              subsist or will subsist now or in the future in any part of the
              world.
            </li>
            <li className="mb-2">
              <b>JL Brand Guidelines</b> means any brand and / or media
              guidelines of JLP which shall be made available to You, upon
              request, from time to time.{" "}
            </li>

            <li className="mb-2">
              <b>JL Policies</b> means JLP’s business policies, as amended from
              time to time, including:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>the Anti-Bribery and Corruption Policy;</span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>JLP Supplier Code of Conduct;</span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (c)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>JLP Responsible Sourcing Code of Practice; and</span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (d)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    any other policies reasonably applicable to this Agreement
                    as notified to You from time to time.
                  </span>
                </Col>
              </Row>
            </li>

            <li className="mb-2">
              <b>Losses</b> means claims, demands, actions, awards, judgments,
              settlements, costs, expenses, liabilities, damages and losses
              (including all interest, fines, penalties, management time and
              legal and other professional costs and expenses and loss or
              corruption of data).
            </li>
            <li className="mb-2">
              <b>Lost Inventory Charge</b> means the charges calculated in
              accordance with Annex 1, as applicable.{" "}
            </li>
            <li className="mb-2">
              <b>Receiving Party</b> means a Party to which a disclosure of
              Confidential Information is made by another Party.
            </li>
            <li className="mb-2">
              <b>Representatives</b> means a Party’s employees, workers,
              directors, licensors, suppliers, contractors, consultants,
              professional advisers, officers, as applicable.
            </li>
            <li className="mb-2">
              <b>Sample(s)</b> means a single, or multiple, example(s) of
              product(s) which are provided by You to JLP for use in the
              Services.
            </li>

            <li className="mb-2">
              <b>Services</b> means the services detailed within the Campaign
              Order and including any ancillary work relating to or arising out
              of those services.{" "}
            </li>
            <li className="mb-2">
              <b>Terms and Conditions</b> means these terms and conditions
              including any annexes and documents referenced herein.
            </li>
          </ul>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>2</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Interpretation</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <p>2.1</p>
            </Col>
            <Col md={10}>
              <span>
                Unless the contrary indication appears, any reference in this
                Agreement to:
              </span>
            </Col>
            <Row className="d-flex flex-col ms-3">
              <Col md={2}>(a)</Col>
              <Col md={10}>
                <span>
                  Clause headings are for ease of reference only and do not form
                  part of or affect the meaning, interpretation or construction
                  of this Agreement;
                </span>
              </Col>
            </Row>
            <Row className="d-flex flex-col ms-3">
              <Col md={2}>(b)</Col>
              <Col md={10}>
                <span>
                  any Applicable Law shall be construed to include a reference
                  to that Applicable Law as from time to time amended, extended,
                  re-enacted or consolidated and any subordinate legislation
                  made pursuant to that Applicable Law;
                </span>
              </Col>
            </Row>
            <Row className="d-flex flex-col ms-3">
              <Col md={2}>(c)</Col>
              <Col md={10}>
                <span>
                  Clauses and Annexes are to clauses of and annexes to this
                  Agreement;
                </span>
              </Col>
            </Row>
            <Row className="d-flex flex-col ms-3">
              <Col md={2}>(d)</Col>
              <Col md={10}>
                <span>
                  the words other, includes, including and in particular do not
                  limit the generality of any preceding words and any words
                  which follow them shall not be construed as being limited in
                  scope to the same class as the preceding words where a wider
                  construction is possible; and
                </span>
              </Col>
            </Row>
            <Row className="d-flex flex-col ms-3">
              <Col md={2}>(e)</Col>
              <Col md={10}>
                <span>
                  a holding company or a subsidiary means (as the case may be)
                  as defined in section 1159 of the Companies Act 2006.
                </span>
              </Col>
            </Row>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <p>2.2</p>
            </Col>
            <Col md={10}>
              The GSCOP Code applies to all contracts for the supply of
              Groceries (as defined within the GSCOP Code), for the purpose of
              resale in the United Kingdom, as well as any subsequent
              contractual agreements or arrangements made under or pursuant or
              in relation to that agreement. Where relevant, insofar as any
              provision of a contract for the supply of Groceries is
              inconsistent with the GSCOP Code, such provision shall be
              unenforceable.
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>3</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Creation of the Agreement:</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <p>3.1</p>
            </Col>
            <Col md={10}>
              <span>
                JLP shall be entitled from time to time to offer the Services to
                You by submitting a Campaign Order to You. You have sole
                discretion to accept a Campaign Order and shall have no
                obligation or liability to JLP should You not accept a Campaign
                Order.
              </span>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <p>3.2</p>
            </Col>
            <Col md={10}>
              Each Campaign Order shall only be valid for a period of five (5)
              Business Days from receipt, unless otherwise agreed by JLP in
              writing. Where Your acceptance of the Campaign Order is provided
              after five (5) Business Days, JLP reserves the right, in its sole
              discretion, to accept or reject such Campaign Order.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <p>3.3</p>
            </Col>
            <Col md={10}>
              Where a Campaign Order is accepted, You agree that it shall be
              governed by the terms of this Agreement.
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>4</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Forming the contract and Order of Precedence: </b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>4.1</Col>
            <Col md={10} className="mb-2">
                The following documents, in the order of precedence below, shall
                collectively form this Agreement:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>GSCOP Code (if applicable);</span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>the Campaign Order;</span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (c)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span> the DPA; and</span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (d)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>these Terms and Conditions.</span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={1}></Col>
                <Col md={11}>
                  <span>
                    In respect of any supply of Goods, to the extent of any
                    conflict between this Agreement and another existing
                    agreement between the Parties in respect of the supply of
                    Goods (the “<b>Goods Supply Contract</b>”), the terms of the
                    Goods Supply Contract shall prevail.{" "}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>5</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Campaign Timetable</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <p>5.1</p>
            </Col>
            <Col md={10}>
              <span>
                Parties shall, acting reasonably and in good faith, work
                collaboratively to agree a Campaign Timetable which may include
                timelines for the submission and approval of all draft Creative
                Material, undertaking certain Campaign Tasks and providing all
                other material as may be reasonably required by JLP (including
                but not limited to any Samples, references to Your brand
                guidelines etc.). JLP shall, acting reasonably, have final
                determination on the Campaign Timetable.
              </span>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>6</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Approval Process for Campaign Material: </b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <p>6.1</p>
            </Col>
            <Col md={10}>
              <span>
                Draft Creative Material must be approved by You within the
                timeframe given within Campaign Timetable or, in the absence of
                a timeframe being provided, soon as reasonably possible. All
                material as may be reasonably required by JLP (including but not
                limited to any Samples, references to Your brand guidelines
                etc.) to finalise the draft Creative Material, must also be
                provided within the same timeframe. In the absence of any
                response within the timeframes herein, JLP may terminate the
                Campaign, whereupon JLP reserves the right to charge You for any
                applicable Cancellation Costs, which shall be payable in
                accordance with Clause 11.
              </span>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>6.2</Col>
            <Col md={10}>
              Where You do not approve the draft Creative Material, You may,
              within the timeframes given within Clause 6.1, request reasonable
              changes to the draft Creative Material. Any request for change to
              the draft Creative Material must also include:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    full details of the modification(s) required along with
                    reasoning as to why such modification is necessary; and
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    all material as may be reasonably required by JLP (including
                    but not limited to any Samples, references to Your brand
                    guidelines etc.), to implement such change to the draft
                    Creative Material.
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={1}>
                  <p></p>
                </Col>
                <Col md={11}>
                  <span>
                    No change to the Creative Material will be considered where
                    that change conflicts with JLP Brand Guidelines.
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <p>6.3</p>
            </Col>
            <Col md={10}>
              <span>
                JLP shall use reasonable endeavours to incorporate changes
                requested under Clause 6.2, however, JLP's decision shall be
                final. JLP shall have no obligation to implement any change
                requested otherwise in accordance with this Clause 6.3.
              </span>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <p>6.4</p>
            </Col>
            <Col md={10}>
              <span>
                Where changes are implemented by JLP to the draft Creative
                Material, JLP shall re-submit the revised draft Creative
                Material to You for Your approval in accordance with Clause 6.1.
                You shall have the right to request changes to that revised
                draft Creative Material in accordance with Clause 6.2, whereby
                the approval process at Clause 6.1 shall be repeated. JLP shall
                not be required to re-submit any subsequent draft Creative
                Material beyond providing a second revision.
              </span>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>7</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Undertaking of Campaign Tasks</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>7.1</Col>
            <Col md={10}>
              You agree that, where a Campaign Task is assigned to You as part
              of the Campaign Timetable, You will perform such Campaign Task in
              accordance with the provisions of this Agreement. Where the
              Campaign Tasks results in You being present at any JLP sites, You
              shall:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    ensure that any area where the Campaign Task is undertaken
                    is left clean and tidy and that all material which is not
                    necessary for the Campaign is removed and all other rubbish
                    collected from the vicinity of the area and You shall remove
                    any such items at the end of the trading day from the site;
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    comply with all reasonable instruction provided to you by
                    JLP staff, in particular but not limited to, instructions
                    related to site security and safety;
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (c)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    {" "}
                    ensure any material You use as part of the Campaign Task
                    shall be of good quality and materials shall be sound and
                    fit for the purpose for which they will be used;{" "}
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (d)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    not cause interference with JLP's usual course of business
                    by causing any nuisance damage disruption or otherwise to
                    JLP or to any other person, and to make good any damage
                    caused to the site or any other property promptly and to the
                    reasonable satisfaction of JLP; and
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (e)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    ensure that completion of the Campaign Task is undertaken to
                    JLP's reasonable satisfaction within the Campaign Timeframe.
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>8</Col>
            <Col md={10} className="mb-2">
              <b>Failure to comply with the Campaign Timetable</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>8.1</Col>
            <Col md={10}>
              Parties agree that time shall be of the essence to comply with the
              Campaign Timetable. Where a task or obligation is assigned to You
              under the Campaign Timetable, or You fail to comply with Your
              obligations at Clause 6.2(b), the Services may be terminated by
              JLP. In this event, JLP reserves the right to charge you for any
              applicable Cancellation Costs, which shall be payable in
              accordance with Clause 11.
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>9</Col>
            <Col md={10} className="mb-2">
              <b>Term</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>9.1</Col>
            <Col md={10}>
              This Agreement shall commence on the earlier of the signature date
              of the Campaign Order, or the date on which JLP starts providing
              the Services and shall (except as expressly provided otherwise in
              this Agreement) continue in force for until completion of the
              Services, unless otherwise terminated in accordance with Clause 20
              (Termination) ("<b>Term</b>").
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>10</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Performance of the Services</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>10.1</Col>
            <Col md={10}>
              Each Party undertakes to perform its obligations under this
              Agreement:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>in accordance with all Applicable Laws; and</span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>using a reasonable degree of skill and care.</span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>10.2</Col>
            <Col md={10}>
              Each Party warrants, represents and undertakes that:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    it has or has obtained such licences or consents in respect
                    of any Intellectual Property Rights as provided in respect
                    of the Services and which are necessary for performance of
                    the Services; and
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    there are no actions, suits or proceedings or regulatory
                    investigations pending or threatened against or affecting
                    that Party before any court or administrative body or
                    arbitration tribunal that might affect its ability to meet
                    and carry out its obligations under this Agreement.
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>10.3</Col>
            <Col md={10}>
              You warrant, represent and undertake that:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    You shall act in accordance with the JL Policies; and
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    all Samples provided by You shall comply with all Applicable
                    Laws and in particular, but not limited to, be of
                    satisfactory quality (within the meaning of the Sale of
                    Goods Act 1979, as amended from time to time) and fit for
                    any purpose held out by You or made known to You by JLP,
                    and, where applicable, be in all material respects
                    equivalent to the Goods sold by You to JLP to which the
                    Sample(s) pertain.
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>11</Col>
            <Col md={10} className="mb-2">
              <b>Charges and Payment</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>11.1</Col>
            <Col md={10}>
              You agree to pay the Charges given within the Campaign Order.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>11.2</Col>
            <Col md={10}>
              JLP shall invoice You for the Charges given on the applicable
              Campaign Order, and You shall make payment of the Charges to JLP
              using the account details and payment instructions provided to You
              by JLP within thirty (30) days of Your receipt of invoice, or as
              otherwise agreed (for example by way of rebate against Your JLP
              supplier account).
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>11.3</Col>
            <Col md={10}>
              If You dispute, in good faith, all or part of any invoice received
              from JLP (either electronically or by other means), You shall
              notify JLP in writing of such dispute as soon as reasonably
              practicable, but no later than twenty (20) days following Your
              receipt of the disputed invoice. As soon as reasonably
              practicable, following receipt of notice of a dispute under this
              Clause 11.3, JLP shall re-issue an invoice for the undisputed
              amount and the earlier invoice shall cease to be payable. On
              resolution of the dispute, JLP may invoice any amounts agreed by
              the Parties (or otherwise determined) to be due. JLP shall provide
              You with any further information reasonably requested by You in
              connection with any invoice which You dispute.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>11.4</Col>
            <Col md={10}>
              The Charges are exclusive of value added tax but include
              packaging, insurance, carriage and all other charges, taxes and
              duties.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>11.5</Col>
            <Col md={10}>
              If any sum due and payable under this Agreement is not paid by You
              in accordance with the agreed payment terms then JLP shall be
              entitled (without prejudice to any of its other rights) to charge
              interest at the rate of four per cent above the base rate of the
              Bank of England from time to time in force from the due date until
              the date of actual payment. The Parties agree that the right to
              claim interest under this Clause 11.5 is a substantial remedy for
              late payment and is in substitution for any statutory or other
              right to claim interest and/or other remedy for late payment under
              the Late Payment of Commercial Debts (Interest) Act 1998.
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>12</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Limitation of liability</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>12.1</Col>
            <Col md={10}>
              Nothing in this Agreement excludes or limits the liability of
              either Party in respect of:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    death or personal injury caused by its negligence (including
                    negligence of its employees, agents or contractors);
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>fraud and/or fraudulent misrepresentation; and</span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (c)
                  <p></p>
                </Col>
                <Col md={10}>
                  any other liability which may not otherwise be limited or
                  excluded under Applicable Laws.
                  <span></span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>12.2</Col>
            <Col md={10}>
              Subject to Clause 12.1, neither Party will be liable to the other
              Party, whether in contract, tort (including negligence), breach of
              statutory duty or otherwise, for any (a) indirect or consequential
              loss; (b) loss of profits, (c) loss of sales or business; (d) loss
              of contracts; (e) loss of use of software; (f) loss or damage to
              goodwill; in each case arising under or in connection with this
              Agreement.
            </Col>
          </Row>

          <Row className="d-flex flex-col mb-3">
            <Col md={2}>12.3</Col>
            <Col md={10}>
              Subject to Clause 12.1, each Party’s total liability to the other:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    arising out of or in connection with any breach of Clause 16
                    (Confidentiality) or Clause 18 (Data Protection); and
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>in respect of the indemnities given at Clause 13;</span>
                </Col>
              </Row>
              shall be limited to £2 million per event or series of connected
              events.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>12.4</Col>
            <Col md={10}>
              Subject to Clause 12.1, Clause 12.2, and Clause 12.3, each Party’s
              total liability to the other arising out of or in connection with
              any Campaign Order, whether arising in contract, tort (including
              negligence), breach of statutory duty or otherwise, shall be
              limited to 100% of the sums paid or payable by You in relation
              that Campaign Order.
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>13</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Indemnities</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>13.1</Col>
            <Col md={10}>
              Each Party will indemnify the other Party against all Losses
              incurred by the indemnified Party, or any member of its group,
              arising out of or in connection with any claim that:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>(in JLP's case) the Creative Material; and</span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    (in Your case) the Samples and/or Your Background IPR
                    provided by You to JLP for use under this Agreement,
                  </span>
                </Col>
              </Row>
              have infringed or will infringe any Intellectual Property Rights
              or any other rights, of a third party.
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>14</Col>
            <Col md={10} className="mb-2">
              <b>Claims handling of Intellectual Property:</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>14.1</Col>
            <Col md={10}>
              Each Party shall notify the other Party in writing as soon as
              reasonably practicable of any allegation(s) of infringement of the
              other Party's IPR of which it has notice and will not make any
              admissions without the owning Party's prior written consent, such
              consent not to be unreasonably withheld, conditioned or delayed.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>14.2</Col>
            <Col md={10}>
              Subject to Clauses 14.3, at the indemnifying Party's request and
              expense, and subject to the indemnifying Party assuming control
              over the defence and/or settlement of the claim within a
              reasonable period of time, the indemnified Party shall permit the
              indemnifying Party to have control of and settle all negotiations
              and deal with the defence of the claim which shall be reasonably
              conducted by the indemnifying Party and subject always to the
              indemnified Party’s consent to any defence or proposed settlement.
              The indemnified Party shall, at the indemnifying Party's request
              and expense, afford reasonable assistance with such negotiations
              or litigation.
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>15</Col>
            <Col md={10} className="mb-2">
              <b>Insurance:</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>15.1</Col>
            <Col md={10}>
              Each Party shall, during the Term and for a period of six (6)
              years after termination of this Agreement for any reason, take out
              and maintain with reputable insurers such policies of insurance as
              may be necessary to insure it against, and adequately cover it
              for, all manner of risks that might arise out of its acts or
              omissions or otherwise in connection with its performance of its
              obligations under this Agreement. In the event that Your Campaign
              Tasks include provision of Samples and/or result You being present
              at any JLP sites, Your policies of insurance shall include
              appropriate levels of product liability and public liability
              cover.
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>16</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Confidentiality</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>16.1</Col>
            <Col md={10}>
              Each Party shall keep the Confidential Information confidential
              between the Parties and shall not use or copy or disclose to any
              third party the Confidential Information or any part thereof
              except:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    for the proper performance of its responsibilities under
                    this Agreement; and
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    subject to Clause 16.2, to any JLP Service providers only
                    for the proper performance of the Party’s responsibility
                    under this Agreement.
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (c)
                  <p></p>
                </Col>
                <Col md={10}>
                  any other liability which may not otherwise be limited or
                  excluded under Applicable Laws.
                  <span></span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>16.2</Col>
            <Col md={10}>
              Each Party may disclose Confidential Information in accordance
              with Clause 16.2 only where:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    it informs the recipient of the confidential nature of the
                    Confidential Information before disclosure; and
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    at all times it is responsible for any recipient’s
                    compliance with the confidentiality obligations set out in
                    this Clause 16.
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>16.3</Col>
            <Col md={10}>
              On expiry or termination of the Agreement or when requested by
              JLP, You shall, at its own cost, at JLP’s option, either return or
              permanently destroy any records or copies in whatever form and/or
              irretrievably delete the same if stored on electronic or magnetic
              media of any material containing Confidential Information
              belonging or relating to JLP or any member of its Group (in
              machine-readable form or otherwise) and shall produce a signed
              undertaking confirming that it has not retained copies of any such
              materials or items.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>16.4</Col>
            <Col md={10}>
              Notwithstanding Clause 16.3, You may retain documents and
              materials containing, reflecting, incorporating or based on the
              other Party’s Confidential Information to the extent required by
              Clause 16.1.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>16.5</Col>
            <Col md={10}>
              The provisions of Clause 16.1 shall not apply to:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    any information in the public domain or which becomes so at
                    a future date otherwise than as a result of a breach of any
                    confidentiality obligation; or
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  information which was already in the possession of the
                  recipient, otherwise than as a result of a breach of any
                  confidentiality obligation; or
                  <span></span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (c)
                  <p></p>
                </Col>
                <Col md={10}>
                  information obtained from a third party who is free to divulge
                  the same; or
                  <span></span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (d)
                  <p></p>
                </Col>
                <Col md={10}>
                  any information which is required to be used or disclosed by
                  Applicable Law.
                  <span></span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>16.6</Col>
            <Col md={10}>
              The Parties agree that damages may not be an adequate remedy for
              any breach of this Clause 16 by either Party or any other person
              authorised to receive Confidential Information pursuant to this
              Clause 16 and each Party shall be entitled to seek any legal
              and/or equitable relief, including an injunction, in the event of
              any threatened or actual breach of the provisions of this Clause
              16 by the other Party in addition to its other remedies at law, in
              equity and under this Agreement and the other Party agrees that it
              shall not resist or defend any such application.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>16.7</Col>
            <Col md={10}>
              If a Party is required to make a disclosure of Confidential
              Information as contemplated by Clause 16.5(d), it shall only
              disclose the minimum Confidential Information required and shall,
              where lawful, consult with the other Party’s contract manager
              prior to any such disclosure.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>16.8</Col>
            <Col md={10}>
              JLP shall be entitled to advertise or publicly announce that it is
              undertaking or has undertaken work for or provided the Services to
              Customer. You shall be entitled to advertise or publicly announce
              the Services provided You have obtained JLP's prior written
              consent (such consent not to be unreasonably withheld or delayed).
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>17</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Intellectual Property Rights</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>17.1</Col>
            <Col md={10}>
              Each Party agrees and acknowledges that it shall not have or gain
              title to nor, except to the extent expressly licensed for use
              under this Agreement, have or gain any licence to use or make any
              modification in respect of any of the other Party’s Background
              IPR. Neither Party will make any representation nor do or permit
              to be done any act which may be taken to indicate that it has any
              right (including any Intellectual Property Rights), title or
              interest in or to the ownership of the other Party’s Background
              IPR.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>17.2</Col>
            <Col md={10}>
              You grant to JLP a world-wide, perpetual, irrevocable,
              non-exclusive, assignable, transferrable, royalty-free licence
              (with full right to sublicense) to use, reproduce, exploit,
              modify, alter and integrate Your Background IPR as part of the
              Services, in all cases only to the extent necessary for the
              purpose of the provision of the Services. Subject to the
              foregoing, neither JLP (nor any third party to whom Your
              Background IPR is licenced) may otherwise assign, license,
              sub-license, grant security over or otherwise transfer Your
              Background IPR.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>17.3</Col>
            <Col md={10}>
              JLP shall own the Campaign IPR. Subject always to Your Background
              IPR, any Campaign IPR created in the course of the Services or
              creating any Campaign are assigned on creation with absolute title
              to JLP by You, and in case of copyright by way of a present
              assignment of future copyright, including the right to sue for
              past infringement. You shall execute any documents and do all acts
              required by JLP for the purpose of confirming such assignment.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>17.4</Col>
            <Col md={10}>
              You shall ensure and undertake to procure that all moral rights,
              to which any individual is now or may be at any future time
              entitled in any jurisdiction, in any Campaign Material are not
              asserted.
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>18</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Data protection:</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>18.1</Col>
            <Col md={10}>
              Each Party shall comply with all Data Protection Laws in relation
              to any Personal Data Processed in connection with the Services
              supplied under this Agreement.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>18.2</Col>
            <Col md={10}>
              Unless otherwise agreed between the Parties in writing and to the
              extent that the Services include providing You with Personal Data
              in respect of which JLP is the data controller (as defined in the
              Data Protection Laws) for the purposes of delivering Samples or
              any Campaign Material directly to JLP’s customers, Parties agree
              that the terms of the DPA shall be incorporated into this
              Agreement.
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>19</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Availability of Goods</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>19.1</Col>
            <Col md={10}>
              Prior to the launch of any Campaign, Parties shall use reasonable
              endeavours to collaborate and prepare a forecasted volume for the
              Goods subject to the Campaign. Parties agree that forecasted
              volumes are indicative, and do not guarantee a minimum or maximum
              quantity. Any such forecasts given by JLP to You shall be provided
              in good faith to assist with the production planning and material
              purchase in advance of the Campaign. A Campaign Order shall not
              form a volume order for Goods under this Agreement or under any
              other agreement.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>19.2</Col>
            <Col md={10}>
              You acknowledge and agree that where customer demand cannot be met
              due to a shortfall in the supply of Goods to JLP, a Campaign may
              be cancelled or delayed. Where a Campaign is cancelled or delayed
              due to insufficient Goods being supplied by You to JLP to meet
              demand, JLP reserves the right to charge you for any applicable
              Cancellation Costs, which shall be payable in accordance with
              Clause 11.
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>20</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Termination</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>20.1</Col>
            <Col md={10}>
              Either Party may terminate this Agreement in its entirety and / or
              any specified Campaign Order(s) by notice to the other Party in
              the event that the Goods Supply Agreement terminates or expires or
              if the other Party:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    commits a material breach of the Agreement which is not
                    capable of remedy, or which is capable of remedy but it
                    fails to remedy that breach within ten (10) Business Days
                    from the date of a notice requiring it to be remedied;
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    persists in any breach of any of its obligations under this
                    Agreement which, by their persistence, have become material,
                    for ten (10) Business Days after having been required in
                    writing to remedy or desist from such breach;
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (c)
                  <p></p>
                </Col>
                <Col md={10}>
                  goes, or is reasonably likely to go, into liquidation (except
                  for the purpose of solvent amalgamation or reconstruction),
                  administration, or receivership;
                  <span></span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (d)
                  <p></p>
                </Col>
                <Col md={10}>
                  enters into an arrangement or compromise with its creditors or
                  takes steps to do so;
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (e)
                  <p></p>
                </Col>
                <Col md={10}>
                  is deemedunable to pay its debts as they fall due as defined
                  within Insolvency Act 1986, or suffers similar events to the
                  above in any other jurisdiction; and / or
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (f)
                  <p></p>
                </Col>
                <Col md={10}>undergoes a change of control.</Col>
              </Row>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>20.2</Col>
            <Col md={10}>
              Without prejudice to any other right or remedy it may have either
              within this Agreement, at law or in equity, JLP may on written
              notice to You, terminate this Agreement in its entirety
              immediately if
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    You undergo a change in Control or if Your holding company
                    or all or substantially all of Your assets are transferred
                    to a third party; or
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    You do or omit to do anything which will bring JLP's or the
                    JLP Group’s reputation and/or the JLP's or JLP Group’s
                    Intellectual Property into disrepute.
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="d-flex flex-col mb-3">
            <Col md={2}>20.3</Col>
            <Col md={10}>
              You may terminate this Agreement on written notice to JLP at any
              time provided that JLP reserves the right to charge You the
              following cancellation costs:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    costs incurred by JLP up until the date of termination for
                    work undertaken by JLP to build the Creative Material
                    (including, but not limited to, any drafts, content or
                    formats); and
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  Lost Inventory Charge;
                  <span></span>
                </Col>
              </Row>
              which shall be payable in accordance with Clause 11
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>21</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Corruption, bribery and financial crime</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>21.1</Col>
            <Col md={10}>
              You shall:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    at all times comply with all Applicable Laws and sanctions
                    and not engage in any activity, practice or conduct which
                    would constitute an offence relating to anti-bribery,
                    corruption, financial crime and anti-slavery and human
                    trafficking including but not limited to the Bribery Act
                    2010 (Bribery Act), Criminal Finances Act 2017 (CFA) and
                    Modern Slavery Act 2015 (MSA); and
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    not engage in any activity, practice or conduct which would
                    constitute an offence by it under the Bribery Act, the CFA
                    or the MSA; and
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (c)
                  <p></p>
                </Col>
                <Col md={10}>
                  under the Bribery Act, the CFA or the MSA; and keep at Your
                  main place of business detailed, accurate and up to date
                  records and books of account that are sufficient to enable the
                  verification of Your compliance.
                  <span></span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>21.2</Col>
            <Col md={10}>
              You shall:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    devise, implement, enforce and maintain written policies and
                    procedures constituting adequate procedures under the
                    Bribery Act and CFA; and
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    promptly report to JLP if, in connection with this
                    Agreement, You have reasonable grounds to believe You may
                    have committed an offence under the CFA or have been or
                    become the subject of any investigation, inquiry or
                    enforcement proceedings by any governmental, administrative
                    or regulatory body regarding any offence under the Bribery
                    Act or CFA.
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>22</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Force Majeure</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>22.1</Col>
            <Col md={10}>
              Neither Party shall in any circumstances be liable to the other
              for any delay or non-performance of its obligations under this
              Agreement to the extent that such delay or non-performance is due
              to a Force Majeure Event.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>22.2</Col>
            <Col md={10}>
              If a Party is delayed in or prevented from performing its
              obligations under this Agreement by a Force Majeure Event, such
              Party shall:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    give notice in writing of such delay or prevention to the
                    other Party specifying the nature and extent of the Force
                    Majeure Event immediately on becoming aware of it; and
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    use all reasonable endeavours to mitigate the effects of the
                    Force Majeure Event on the performance of its obligations.
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>22.3</Col>
            <Col md={10}>
              If the Force Majeure Event continues for a period of 30 days or
              more following notification, the Party not affected by the Force
              Majeure Event may terminate this Agreement by giving not less than
              ten (10) Business Days' prior written notice to the other Party.
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>23</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Assignment and sub-contracting</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>23.1</Col>
            <Col md={10}>
              Each Party shall not be entitled to assign, transfer, hold on
              trust or otherwise deal with any of its rights and obligations
              arising under or in connection with this except: (i) to a member
              of that Party’s Group, or (ii) with the other Party’s prior
              express written consent which the other Party may grant or
              withhold in its absolute discretion.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>23.1</Col>
            <Col md={10}>
              Either Party may appoint sub-contractors to undertake or perform
              its obligations under this Agreement. Each Party shall remain
              liable to the other Party for any performance or non-performance
              of its obligations under this Agreement, whether by that Party or
              its sub-contractors.
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>24</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>General</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>24.1</Col>
            <Col md={10}>
              Nothing in this Agreement is intended to, or shall be deemed to,
              establish any partnership or joint venture between any of the
              Parties, constitute any Party the agent of another Party, or
              authorise any Party to make or enter into any commitments for or
              on behalf of any other Party. Each Party confirms it is acting on
              its own behalf and not for the benefit of any other person.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>24.2</Col>
            <Col md={10}>
              No change to this Agreement shall be valid or effective unless it
              is in writing and signed for and on behalf of each Party by the
              Party’s duly authorised representative.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>24.3</Col>
            <Col md={10}>
              The rights and remedies of the Parties in connection with this
              Agreement are cumulative and, except as expressly stated in this
              Agreement, are not exclusive of any other rights or remedies
              provided by this Agreement, at law, in equity or otherwise.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>24.4</Col>
            <Col md={10}>
              A person who is not a party to this Agreement shall have no rights
              under the Contracts (Rights of Third Parties) Act 1999 to enforce
              any provisions of this Agreement, except that each member of the
              JLP Group shall have the benefit of all rights, benefits,
              indemnities and limitations provided for in this Agreement and
              accordingly shall be entitled to enforce this Agreement subject to
              and in accordance with its terms.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>24.5</Col>
            <Col md={10}>
              Notices for service on JLP in any legal action may be sent by
              email to company.secretariat@johnlewis.co.uk. Otherwise, notices
              may be sent by hand or by post to the other’s registered office
              address. Notices are deemed delivered two (2) Business Days after
              posting (where posted), immediately (where delivered by hand), and
              immediately provided no bounce back has been received (where
              emailed).
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>24.6</Col>
            <Col md={10}>
              The failure of either party to enforce or to exercise at any time
              or for any period of time any term of or any right pursuant to
              this Agreement does not constitute, and shall not be construed as,
              a waiver of such term or right and shall in no way affect that
              party’s right later to enforce or to exercise it.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>24.7</Col>
            <Col md={10}>
              If any provision or part-provision of this Agreement is or becomes
              illegal, invalid or unenforceable, the provision will apply with
              whatever minimum level of deletion or modification is necessary so
              that the provision is legal, valid and enforceable and gives
              effect to the Parties’ commercial intention.
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>24.8</Col>
            <Col md={10}>
              This Agreement sets out the entire agreement and understanding
              between the Parties relating to its subject matter.
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>25</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Dispute resolution:</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>25.1</Col>
            <Col md={10}>
              Initial contacts:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    The initial contact for JLP shall be the JLP Media Sales
                    Team; and
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    The initial contact for You shall be the equivalent
                    counterpart.
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>25.2</Col>
            <Col md={10}>
              Senior authorities
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    The senior authority for JLP shall be the Head of Media
                    Sales; and
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    The senior authority for You shall be the equivalent
                    counterpart.
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>25.4</Col>
            <Col md={10}>
              Subject to Clause 26, if a Dispute arises between JLP and
              Yourselves during the Term in relation to any matter which cannot
              be resolved by local operational management, either Party may
              refer the matter for determination in accordance with the
              following procedure:
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (a)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    by referral in the first instance to the decision of the
                    initial contact for each of the Parties; and
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (b)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    if a Dispute is not resolved within 14 days of its referral
                    pursuant to Clause 25.1 above, such Dispute shall be
                    referred to the senior authority for each of the Parties;
                    and
                  </span>
                </Col>
              </Row>
              <Row className="d-flex flex-col ms-3">
                <Col md={2}>
                  (c)
                  <p></p>
                </Col>
                <Col md={10}>
                  <span>
                    if a Dispute is not resolved within 14 days of its referral
                    pursuant to Clause 25.2 above, such Dispute shall be
                    resolved by litigation in the courts of England pursuant to
                    the governing law as set out on the front page of this
                    Agreement.
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>26</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Dispute under GSCOP:</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>26.1</Col>
            <Col md={10}>
              Where the GSCOP Code applies, any dispute arising under Articles
              11(2) or 11(3) of the Groceries (Supply Chain Practices) Market
              Investigation Order 2009 (GSCOP Order) will be exclusively dealt
              with in accordance with the dispute resolution scheme in Article
              11 of the GSCOP Order.
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>
              <b>27</b>
            </Col>
            <Col md={10} className="mb-2">
              <b>Governing Law and Jurisdiction:</b>
            </Col>
          </Row>
          <Row className="d-flex flex-col mb-3">
            <Col md={2}>27.1</Col>
            <Col md={10}>
              This Agreement and any non-contractual disputes or claims arising
              out of or in connection with it is governed by and shall be
              interpreted in accordance with English law. Each Party irrevocably
              submits to the exclusive jurisdiction of the courts of England and
              Wales in relation to all matters (whether contractual or
              non-contractual) arising out of or in connection with this
              Agreement.
            </Col>
          </Row>
        </Container>
        <Container className="mb-4">
          <Row className="d-flex flex-col mb-3">
            <b className="">Annex 1</b>
            <Image src="/assets/annex.png" />
            <p>*In all cases, the “charge” is the amount payable by the Supplier for the relevant media feature.</p>
          </Row>
        </Container>
      </Container>
    </Container>
  );
};

export default TermsAndConditions;
